import {
  groupedRegionColorMap
} from '../../Utils';

const getColor = (region: string) => {
  const retrievedColor = groupedRegionColorMap.get(region);
  if (retrievedColor === undefined) {
    throw new Error('Cannot find color for region ' + region);
  }
  return retrievedColor;
};

export default getColor;
